/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import PharmacyStockIndent from './pharmacy-stock-indent';
import PharmacyStockIndentDetail from './pharmacy-stock-indent-detail';
import PharmacyStockIndentUpdate from './pharmacy-stock-indent-update';
import PharmacyStockIndentDeleteDialog from './pharmacy-stock-indent-delete-dialog';

const PharmacyStockIndentRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<PharmacyStockIndent />} />
    <Route path="new" element={<PharmacyStockIndentUpdate />} />
    <Route path=":id">
      <Route index element={<PharmacyStockIndentDetail />} />
      <Route path="edit" element={<PharmacyStockIndentUpdate />} />
      <Route path="delete" element={<PharmacyStockIndentDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default PharmacyStockIndentRoutes;
